export default __webpack_public_path__ + "static/media/driver.5066fb9f.svg";